module.exports = __webpack_public_path__ + "img/talk_icon.dab117b2.png";